
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/ProjectFilterOrganization/ProjectFilterOrganization.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./ProjectFilterOrganization.html');
        
        var script = require('./ProjectFilterOrganization.ts').default;
        module.exports = require('./ProjectFilterOrganization.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    